module.exports = __webpack_public_path__ + "img/功能架构.789a37b5.png";